module.exports = "pegasus/assets/facebook.png";